export default "__VITE_ASSET__Drgmdnqt__"